/**
 * 需求来源：docs/合作页、CJ Entity、Ads开户落地页3个/AI提示词.md（第2次提交 任务2）。
 * Brand Assets 区块（partnership_home.html 第 4527 行起）：品牌资源下载，静态内容 + 目标页图片 URL 原样保留。
 * 注意事项：静态文案取自 props.t（getConstants().BRAND，i18next 六国翻译）；卡片图片文件名与目标页一致。
 */
import React from 'react';

const IMG_BASE = 'https://www.cjdropshipping.com/egg/image/partnership';
/**
 * 260713163000（第8次补充 任务1.4）：下载必须直接落地本地。
 * 原页 app/view/partnership/home.njk:80 用【同源相对路径】 `/egg/image/partnership/<file>` + download 才能触发下载；
 * 此前 BrandAssets 用跨域绝对 URL(IMG_BASE) 导致浏览器忽略 download 变成新开页。
 * 故下载 href 改用同源相对路径 DOWNLOAD_BASE（资源已存在于 public/egg/image/partnership/），图片显示 src 仍用 IMG_BASE。
 */
const DOWNLOAD_BASE = '/egg/image/partnership';

export default function BrandAssets({ t }) {
  const c = t || {};
  const cards = c.cards || [];
  return (
    <section className="cj-brand-assets">
      <div className="cj-brand-assets-container">
        <div className="cj-brand-assets-label">{c.label}</div>
        <h2 className="cj-brand-assets-title">{c.title}</h2>
        <p className="cj-brand-assets-description">{c.desc}</p>

        <div className="cj-brand-assets-grid">
          {cards.map((card) => {
            // 260715 第17次补充(需求㊷)：不再引用跨域外链，显示与下载均走同源 /egg/image/partnership/<file>
            //   (品牌 SVG 已存在于 public/egg/image/partnership/，同源非外链；下载仍靠同源 download 触发)
            const imgSrc = DOWNLOAD_BASE + '/' + card.file;
            const downloadHref = DOWNLOAD_BASE + '/' + card.file;
            return (
              <article className="cj-brand-card" key={card.file}>
                <div className={'cj-brand-card-preview ' + card.previewCls}>
                  <img src={imgSrc} alt={card.title} loading="lazy" />
                </div>
                <div className="cj-brand-card-content">
                  <div className="cj-brand-card-heading">
                    <h3 className="cj-brand-card-title">{card.title}</h3>
                    <span className="cj-brand-card-format">{c.format}</span>
                  </div>
                  <p className="cj-brand-card-text">{card.text}</p>
                  {/* 260713163000（第8次补充 任务1.4）：同源相对 href + download，去掉 target=_blank，与原页一致直接下载 */}
                  <a
                    className="cj-brand-download"
                    href={downloadHref}
                    download={card.file}
                    aria-label={typeof c.downloadAria === 'function' ? c.downloadAria(card.alt) : c.download}
                  >
                    <span>{c.download}</span>
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M12 3v12" />
                      <path d="m7 10 5 5 5-5" />
                      <path d="M5 21h14" />
                    </svg>
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
